import { NOTIFICATION_API_URL } from 'api/APIBase';

// exported websocket helpers in separate file to avoid cyclic dependencies
export const SocketTypes = {
    NOTIFICATION: 'NOTIFICATION_SOCKET',
} as const;
export type SocketType = (typeof SocketTypes)[keyof typeof SocketTypes];

// API constant
export const SocketURLMap = {
    [SocketTypes.NOTIFICATION]: NOTIFICATION_API_URL,
} as const;

const wsHttpBase = (): string =>
    process.env.REACT_APP_WS_BASE_URL ?? process.env.REACT_APP_BASE_URL;

export const getSocketURL = (socketType: SocketType) =>
    `${wsHttpBase().replace('http', 'ws')}${SocketURLMap[socketType]}`;

export const wsConnect = ({ socketType }: { socketType: SocketType }) => ({
    type: 'WS_CONNECT',
    socketType,
});
export const wsEnsureConnected = ({ socketType }: { socketType: SocketType }) => ({
    type: 'WS_ENSURE_CONNECTED',
    socketType,
});
export const wsDisconnect = ({ socketType }: { socketType: SocketType }) => ({
    type: 'WS_DISCONNECT',
    socketType,
});
export const wsSend = ({
    socketType,
    messageType,
    message,
}: {
    socketType: SocketType;
    messageType: string;
    message: unknown;
}) => ({
    type: 'WS_SEND',
    socketType,
    messageType,
    message,
});
